import { TeamsContainer } from "./styles";
import { MatchViewerRowedTeam } from "./MatchViewerRowedTeam";
import { getMatchRosterOrPlaceholderIds, Match } from "model/Match/Match";
import { getRosterDisplayScore } from "model/Match/MatchScore";

interface Props {
  match: Match;
  tournamentId: string;
}

export const MatchViewerRowedTeams = ({ match, tournamentId }: Props) => {
  const rosterIds = getMatchRosterOrPlaceholderIds(match);
  const shouldUseDoubleRow = rosterIds.length > 6;
  const teamsInFirstRow = Math.ceil(rosterIds.length / 2);

  if (!shouldUseDoubleRow) {
    return (
      <TeamsContainer>
        {rosterIds.map((rosterId, idx) => (
          <MatchViewerRowedTeam
            key={`${idx}: ${rosterId}`}
            rosterId={rosterId}
            tournamentId={tournamentId}
            scoreString={getRosterDisplayScore(match, rosterId) ?? "-"}
          />
        ))}
      </TeamsContainer>
    );
  }

  return (
    <>
      <TeamsContainer>
        {rosterIds.slice(0, teamsInFirstRow).map((rosterId, idx) => (
          <MatchViewerRowedTeam
            key={`${idx}: ${rosterId}`}
            rosterId={rosterId}
            tournamentId={tournamentId}
            scoreString={getRosterDisplayScore(match, rosterId) ?? "-"}
          />
        ))}
      </TeamsContainer>
      <TeamsContainer>
        {rosterIds.slice(teamsInFirstRow).map((rosterId, idx) => (
          <MatchViewerRowedTeam
            key={`${idx}: ${rosterId}`}
            rosterId={rosterId}
            tournamentId={tournamentId}
            scoreString={getRosterDisplayScore(match, rosterId) ?? "-"}
          />
        ))}
      </TeamsContainer>
    </>
  );
};
